import { render } from "./RelationshipSide.vue?vue&type=template&id=b76679ae&ts=true"
import script from "./RelationshipSide.vue?vue&type=script&lang=ts"
export * from "./RelationshipSide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__